import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=68b3ee86"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports